import _ from 'lodash';
import React from 'react';

import BrandInfoModelLink from 'components/pages/brand/BrandInfoModelLink';
import { BrandInfoModels } from 'types/drupal/BrandInfo';

interface Props {
    brand: string;
    brandModels: BrandInfoModels[];
    year: string;
}
const BrandInfoModelLinks: React.StatelessComponent<Props> = (props: Props) => {
    const links = _.map(props.brandModels, (brandModel)  => {
        return (<BrandInfoModelLink key={brandModel.slug} brand={props.brand} brandModel={brandModel} year={props.year} isMobile={false} />);
    });
    return (<div>{links}</div>);
};

export default BrandInfoModelLinks;



// WEBPACK FOOTER //
// ./src/components/pages/brand/BrandInfoModelLinks.tsx